import React from "react";

import teamBadgePlaceholder from "../../../../assets/images/team_badge_placeholder.svg";

const ReadOnlyTeamSlot = ({ name, crest }) => (
  <div className="w-full px-[16px] py-[8px] bg-app-surface rounded-full flex items-center">
    <div className="flex gap-[8px] items-center">
      {name ? (
        <>
          <img
            src={crest || teamBadgePlaceholder}
            alt={name}
            className="w-5 h-5 rounded-full object-cover shrink-0 border border-[#192634]"
            onError={(e) => { e.target.src = teamBadgePlaceholder; }}
          />
          <span className="text-app-text text-[14px] font-medium truncate">
            {name}
          </span>
        </>
      ) : (
        <span className="text-app-text-secondary text-[14px] font-medium">
          TBD
        </span>
      )}
    </div>
  </div>
);

const CustomMatchesBlock = ({ customBlock, getTeamById }) => {
  const fixtures = customBlock.fixtures || [];

  const resolveTeam = (fixture, side) => {
    let name = null;
    let crest = null;
    if (side === "home") {
      name = fixture.homeTeamName || fixture.homeTeam?.title || fixture.homeTeam?.name;
      crest = fixture.homeTeamCrest || fixture.homeTeam?.crest || fixture.homeTeam?.logo;
    } else {
      name = fixture.awayTeamName || fixture.awayTeam?.title || fixture.awayTeam?.name;
      crest = fixture.awayTeamCrest || fixture.awayTeam?.crest || fixture.awayTeam?.logo;
    }
    if (!name) {
      const id = side === "home" ? fixture.homeTeamId : fixture.awayTeamId;
      name = getTeamById(id) || null;
    }
    return { name, crest };
  };

  return (
    <div className="flex flex-col items-start gap-[12px] w-full">
      {/* Header */}
      <div className="flex justify-between items-center w-full">
        <span className="text-[#B2B5AD] text-[14px] font-semibold">
          Custom Matches
        </span>
      </div>

      {/* Fixtures */}
      {fixtures.length === 0 ? (
        <div className="w-full flex justify-center items-center text-sm text-[#7F8585] py-6 border border-dashed border-[#192634] rounded-lg">
          No custom matches yet.
        </div>
      ) : (
        <div className={`${fixtures.length > 1 && "grid grid-cols-2"} gap-[12px] w-full`}>
          {fixtures.map((fixture, idx) => (
            <div
              key={fixture._id || idx}
              className="flex flex-col max-w-[245px] items-start gap-[12px] px-[16px] py-[12px] border border-[#192634] rounded-[20px] bg-[#011224]"
            >
              {/* Match header */}
              <div className="w-full flex justify-between items-center">
                <h6 className="text-[#B2B5AD] text-[14px] font-semibold m-0">
                  {fixture.name || `Match ${idx + 1}`}
                </h6>
              </div>

              {/* Team slots — read-only */}
              <div className="w-full flex flex-col gap-[12px]">
                <ReadOnlyTeamSlot {...resolveTeam(fixture, "home")} />
                <ReadOnlyTeamSlot {...resolveTeam(fixture, "away")} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomMatchesBlock;
